import { validateUrl } from 'utilities/validations/urls'
import {
  Highlight,
  HighlightEditorErrors,
  HighlightEditorStore,
} from '../types/highlights'

export const validateHighlightData = (
  highlight: Partial<Highlight>,
  set: (data: Partial<HighlightEditorStore>) => void
) => {
  const fieldsRequired = ['title', 'image', 'contentLink', 'contentType']
  const errors: HighlightEditorErrors[] = []

  fieldsRequired.forEach((field) => {
    let isValid = true
    let error

    if (!highlight?.[field]) {
      isValid = false
    }

    if (field === 'contentLink') {
      const validUrl = validateUrl(highlight?.[field] || '')
      if (!validUrl) {
        isValid = false
        error = {
          label: field,
          message: 'Please enter a valid url',
        }
      }
    }

    if (field === 'image' && !isValid) {
      error = {
        label: field,
        message: 'Please upload an image',
      }
    }

    if (!isValid && !error) {
      error = {
        label: field,
        message: 'This field is required',
      }
    }
    if (error) {
      errors.push(error)
    }
  })

  set({ errors })

  return errors.length === 0
}

export const validateHighlightErrorByLabel = (
  label: keyof Highlight,
  erros: HighlightEditorErrors[]
) => {
  if (!erros) {
    return undefined
  }

  const error = erros.find((error) => error.label === label)
  return error?.message
}
